import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';

import actions from './actions';

import ListaAcoes from '../../components/ListaAcoes';
import constants from './constants';

class ListaProblemas extends Component {
  onStartCancel(value) {
    alert(1);
    this.setState({
      value
    });
  }

  render () {
    const { children, ...otherProps } = this.props;
    return <ListaAcoes {...otherProps}>{children}</ListaAcoes>
  }
}

ListaProblemas.defaultProps = {
  tipo: "pendencias",
  labelFn: (item, t) => {
    let { data, tipo, usuario, atencao, id, status, ...outros } = item;

    let formattedDate = moment(data).format('DD / MM');
    let formattedUsuario = t("pendencias:usuarios." + tipo, usuario, item);
    let formattedTipo = t("pendencias:tipos." + tipo, item);
    let chaves = Object.keys(outros).filter(v => outros[v]);

    return chaves.length?<details><summary>
      {formattedDate} : {formattedUsuario}
      <br />
      {formattedTipo}</summary>
      <ul>
        {chaves.map((v, i) => <li key={i}>{t("pendencias:labelDetalhe." + tipo + "." + v)}<br />{outros[v]}</li>)}
      </ul>
    </details>:<div>
    {formattedDate} : {formattedUsuario}
    <br />
    {formattedTipo}</div>;
  }
};

let mapStateToProps = ({ admin: { problemas } }) => ({
  value: problemas
});

let mapDispatchToProps = dispatch => {
  let action = bindActionCreators(actions, dispatch);

  return {
    actions: {
      onLoad: action.onLoadListPendencias,
      onCancel: action.onChangeListPendencias(constants.Status.CANCELADA),
      onApprove: action.onChangeListPendencias(constants.Status.CONFIRMADA),
      onCreate: action.onChangeListPendencias(constants.Status.CONFIRMADA)
    }    
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ListaProblemas);



// WEBPACK FOOTER //
// ./src/modules/admin/ListaProblemas.js